window.onload = function () {
    populateEmail();
};

function populateEmail() {
    // the first element of each subarray is the ATS name, and the rest are the contact email addresses.
    var atsNamesAndEmails = [
        ["Abso","ClientServices^^^abso.com"],
        ["Advorto","david.pryce^^^advorto.com"],
        ["Apoint+","andy.pierson^^^networxrecruitment.net"],
        ["Applitrack","abe^^^aspexsolutions.com","support^^^aspexsolutions.com"],
        ["bfound.net","gayleen^^^findly.com","caro^^^findly.com"],
        ["Big Red Sky","chris.savage^^^thomsonreuters.com","sales^^^bigredsky.com"],
        ["Brassring","ggopal^^^us.ibm.com"],
        ["Changeworknow","Lisa.Proctor^^^changeworknow.co.uk","Sharon.Wilson^^^changeworknow.co.uk"],
        ["Connexys","meijer^^^connexys.com","bentvelzen^^^connexys.com"],
        ["CV Tools","jorgeoriol^^^cvtools.com","ferran^^^cvtools.com","cvtools^^^cvtools.es"],
        ["CVmail","chris.savage^^^thomsonreuters.com","firmsupport^^^cvmail.net"],
        ["CVweb","s.zagaria^^^cesop.it"],
        ["Cyber Recruiter","cpomeroy^^^visibilitysoftware.com","Sales^^^VisibilitySoftware.com"],
        ["eArcu","andy.randall^^^earcu.com"],
        ["Elancers","anunes^^^elancers.net","fabio^^^elancers.net"],
        ["Emply","ga^^^emply.dk","ma^^^emply.net"],
        ["Eploy","chris.bogh^^^eploy.co.uk"],
        ["ERC Dataplus"],
        ["Ezijob/LHR","holt^^^lhr.com.au"],
        ["FastTrack","jquirk^^^fasttrack.com.au","namisano^^^fasttrack.com.au","support^^^fasttrack.com.au"],
        ["Galileo","info^^^galileo-ats.com"],
        ["Halogen Software","beyre^^^halogensoftware.com","mgaines^^^halogensoftware.com","support^^^halogensoftware.co.uk"],
        ["Hirefuel","emary.vasquez^^^employmentguide.com","support^^^hirefuel.zendesk.com"],
        ["HR4YOU","axel.rekemeyer^^^hr4you.de","d.meyer^^^hr4you.de"],
        ["HRLogix","mike.hargrove^^^findly.com","mike^^^findly.com"],
        ["HROffice","hans^^^adver.nl","marjign^^^hroffice.com"],
        ["HRsmart","clientrelations^^^hrsmart.com"],
        ["Humanic","jspirig^^^humanic.com","tmoberg^^^humanic.com"],
        ["HumanSourcing","mc^^^humansourcing.com","e.royer^^^humansourcing.com","info^^^humansourcing.com"],
        ["Humanway"],
        ["I-Recruit","bkelly^^^cmshris.com","dedgecomb^^^cmshris.com"],
        ["iCIMS","iCIMSProdMgrs^^^icims.com"],
        ["Identified(Facebook App)","erik^^^identified.com"],
        ["iGreentree","Support^^^GreentreeSystems.com"],
        ["iKrut"],
        ["Infoniqa","Eugen.Kimmerstorfer^^^infoniqa.com"],
        ["Jobaline","miki^^^jobaline.com"],
        ["JobApp Plus","jdipaulo^^^jobappplus.com","Info^^^JobAppPlus.com"],
        ["Jobtrain"],
        ["Jobtrain","charles.england^^^jobtrain.co.uk"],
        ["Jobvite","skip^^^jobvite.com"],
        ["Kombo","alessandro^^^kombo.com.br","contato^^^kombo.com.br"],
        ["Kronos","lynne.levy^^^kronos.com","customerupdates^^^kronos.com"],
        ["Leme Consultoria","elsimar^^^lemeconsultoria.com.br","contato^^^lemeconsultoria.com.br"],
        ["Lever","amy^^^lever.co","kelsey^^^lever.co","support^^^lever.co"],
        ["LG Systemas","mporto^^^lg.com.br"],
        ["Luceo","Molly.Ronovsky^^^luceous.com"],
        ["Lumesse EasyCruit","matthijs.vanetten^^^lumesse.com","shelley.ingram^^^lumesse.com"],
        ["Lumesse I-GRasp","matthijs.vanetten^^^lumesse.com","shelley.ingram^^^lumesse.com"],
        ["Lumesse TalentLink","matthijs.vanetten^^^lumesse.com","shelley.ingram^^^lumesse.com"],
        ["Navicus","jherron^^^navicus.com"],
        ["NewHire","csmith^^^new-hire.com"],
        ["Njoyn","info.sales^^^njoyn.com"],
        ["NowHire","SalesSupport^^^nowhire.com"],
        ["PageUp People","simonc^^^pageuppeople.com","peterd^^^pageuppeople.com"],
        ["Parrell Partners","ferdi^^^parallel.co.za","martin^^^parallel.co.za"],
        ["PeopleAnswers","Larry.Chandler^^^infor.com","info^^^peopleanswers.com"],
        ["peoplebank","siobhain.murdoch^^^peoplebank.com"],
        ["Peoplefluent","didier.guzman^^^peoplefluent.com"],
        ["Phoenix ATS","mel^^^phoenixats.com","support^^^PhoenixATS.com"],
        ["Profilsoft"],
        ["Recutsosimple","sales^^^recruitsosimple.co.uk"],
        ["Resfly","tony^^^catsone.com"],
        ["ResumeWare","kirk.boecker^^^resumeware.com","support^^^resumeware.com"],
        ["ResuWe","jeff^^^resuwe.com","questions^^^resuwe.com"],
        ["Rexx systems","arne.nissen^^^rexx-systems.com"],
        ["Scout E-Recruitment","andrea.tjoeng^^^employmentoffice.com.au","will.smith^^^scouterecruit.com"],
        ["Snaphire","mgilmore^^^snaphire.com","hankins^^^snaphire.com","support^^^snaphire.com"],
        ["SortIQ"],["SuccessFactors"],
        ["Talentsoft","contact^^^talentsoft.com"],
        ["Ultimate Software","jennifer_brafman^^^ultimatesoftware.com","ultiproinfo^^^ultimatesoftware.com"],
        ["Unrabble","support^^^unrabble.com"],
        ["Vacancy filler","Fola.Adeniji^^^vacancyfiller.co.uk","Tony.Brookes^^^vacancyfiller.co.uk"],
        ["VirtualEdge","Nathan.Acker^^^adp.com"],
        ["VONQ","wouter^^^vonq.nl"],
        ["WCN","david.moore^^^wcn.co.uk"],
        ["Webcruit"],
        ["willbehired","CCD^^^trinet.com"],
        ["Workbuster"],
        ["Workstream","Liz.Wamsteeker^^^hrsoft.com","info^^^workstreaminc.com"],
        ["World Manager","wendyd^^^worldmanager.com","MarleyV^^^worldmanager.com","ausinfo^^^worldmanager.com"],
        ["Youcruit","mats.holmback^^^youcruit.com"]];

    var emailArray = new Array(); // mailto
    var tempEmail = '';


    // create select box
    var elems = document.getElementsByClassName('ats-form__select');

    var selectAnAts = $('.ats-form__label').text();
    if(selectAnAts === undefined){
        selectAnAts = "Select an ATS";
    }
    addOption(elems, '', selectAnAts);

    // populate options
    for (var i=0; i<atsNamesAndEmails.length; i++) {
        emailArray[i] = '';

        for (var j=1; j<atsNamesAndEmails[i].length; j++) {
            emailArray[i] = emailArray[i] + formatContact(atsNamesAndEmails[i][j]) + ',';
        }
        if (emailArray[i].length) {
            addOption(elems, emailArray[i].slice(0,-1), atsNamesAndEmails[i][0]);
        }
    }

    var other = $('#selectOther').html();
    if(other === undefined){
        other = "Other";
    }

    addOption(elems, '', other);

    //reset select2
    $('.select2').remove();
    var $ats_select = $('select').select2({
        minimumResultsForSearch: Infinity
    });

    $('.ats-form').submit(function(e){
        e.preventDefault();
        sendEmail($ats_select);
    });

}

function sendEmail($ats_select) {

    var bodies = {
        'en': [
            "I'm sending this email to request that you connect our ATS to Indeed as soon as possible. Our ATS is not listed as a connected ATS here: https://www.indeed.com/hire/ats-integration. This means we are missing out on significant benefits other companies have by using an ATS that's connected to Indeed.",
            "One of our most critical recruitment needs is having the ability to attract and source qualified applicants. By connecting our ATS with Indeed, we can nearly double the number of high-quality job seekers that apply to our jobs from Indeed immediately, and at no additional cost. According to recent data from Indeed, employers using a connected ATS received 88% more qualified applicants and experienced a 67% decrease in cost per qualified applicant.",
            "Please contact Indeed's Alliances team to connect our ATS by sending an email to alliancessupport@indeed.com.",
            "Best,"
        ],
        'de': [
            "Mit dieser E-Mail bitten wir Sie, unser ATS so schnell wie möglich mit Indeed zu verbinden. Unser ATS wird nicht als ein mit Indeed integrierbares ATS gelistet: https://de.indeed.com/recruiting/bewerbermanagementsysteme. Dies bedeutet, dass wir die Vorteile, die andere, bereits mit Indeed integrierte Unternehmen genießen, nicht nutzen können.",
            "Zu unseren wichtigsten Recruitment-Bedürfnissen gehört es, geeignete Kandidaten zu gewinnen. Durch die Integration unseres ATS mit Indeed können wir die Anzahl geeigneter Bewerber ohne zusätzliche Kosten sofort deutlich erhöhen.",
            "Bitte kontaktieren Sie das Indeed Alliances Team unter alliancessupport@indeed.com, um unser ATS zu integrieren.",
            "Mit freundlichen Grüßen"
        ],
        'fr': [
            "Je me permets de vous écrire cet email afin de vous encourager à connecter votre ATS à Indeed le plus vite possible. En effet, votre ATS n'est pas listé sur cette page : https://www.indeed.fr/recrutement/integration-ats. Ce qui signifie que vous ne bénéficiez pas d'avantages auxquels d'autres entreprises ont accès en utilisant un ATS qui est connecté à Indeed.",
            "L'un des besoins essentiels lorsque que l'on recrute est la capacité à trouver et attirer des candidats qualifiés. En connectant votre ATS à Indeed, vous pouvez presque doubler instantanément et sans frais supplémentaires le nombre de chercheurs d'emploi de qualité qui postulent à vos offres depuis Indeed.\nD'après les données récentes d'Indeed, les employeurs utilisant un ATS connecté reçoivent 88 % de candidats qualifiés en plus et voient leur coût par candidats qualifiés baisser de 67 %.",
            "Veuillez contacter l'équipe Alliances afin de connecter votre ATS à Indeed en envoyant un email à l'adresse alliancessupport@indeed.com.",
            "Cordialement"
        ],
        'fr_CA': [
            "Je me permets de vous écrire ce courriel afin de vous encourager à connecter votre ATS à Indeed le plus vite possible. En effet, votre ATS n'est pas listé sur cette page : https://emplois.ca.indeed.com/recrutement/integration-ats. Ce qui signifie que vous ne bénéficiez pas de certains des avantages auxquels d'autres entreprises ont accès en utilisant un ATS connecté à Indeed.",
            "L'un des besoins essentiels lorsque que l'on recrute est la capacité à trouver et attirer des candidats qualifiés. En connectant votre ATS à Indeed, vous pouvez presque doubler instantanément et sans frais supplémentaires le nombre de chercheurs d'emploi de qualité qui postulent à vos offres depuis Indeed.\{lbn}D'après les données récentes d'Indeed, les employeurs utilisant un ATS connecté reçoivent 88 % de candidats qualifiés en plus et voient leur coût par candidats qualifiés baisser de 67 %.",
            "Pour connecter votre ATS à Indeed, contactez l'equipe Alliances en envoyant un courriel à alliancessupport@indeed.com.",
            "Cordialement"
        ],
        'es': [
            "Envío este email para solicitar conectar nuestro SSC con Indeed lo antes posible. Nuestro SSC no está incluida aquí: https://www.indeed.com/hire/ats-integration. Esto supone que estamos perdiendo los beneficios que otras empresas obtienen usando un SSC conectado con Indeed.",
            "Una de nuestras necesidades críticas de reclutamiento es atraer y manejar candidatos cualificados. Al conectar nuestro SSC con Indeed, podemos casi duplicar el número de candidatos de alta calidad que postulan a nuestros empleos desde Indeed de forma inmediata y sin coste adicional. Según datos recientes de Indeed, la empresas que usan un SSC conectado reciben un 88% más de candidatos cualificados y disfrutan un descenso del 67% en el coste por candidato cualificado.",
            "Por favor contacte con el equipo de alianzas de Indeed para conectar nuestro SSC enviando un email a alliancessupport@indeed.com.",
            "Un saludo,"
        ],
        'it': [
            "Vi scrivo per richiedere la connessione del vostro ATS con Indeed, il prima possibile. Il vostro ATS non è compreso nella lista degli ATS connessi a Indeed: https://it.indeed.com/recruiting/integrazione-ats. Di conseguenza non stiamo beneficiando dei vantaggi che altre aziende hanno ricevuto con un ATS connesso a Indeed.",
            "Uno dei problemi più importanti nel campo delle risorse umane è quello di attrarre e assumere candidati qualificati. Connettendo il vostro ATS con Indeed, potremmo raddoppiare il numero di candidati qualificati che possono candidarsi alle nostre offerte di lavoro. Sulla base di dati recenti pubblicati da Indeed, le aziende che usano un ATS connesso ricevono l'88% in più di candidati qualificati con un risparmio del 67% per candidato.",
            "Per connettere il vostro ATS, potete contattare l'Alliance Team di Indeed a: alliancessupport@indeed.com.",
            "Cordiali saluti,"
        ],
        'ja': [
            "私達の採用支援システムがIndeed になるべく早期に対応できるよう、メールにて要請します。 以下のページにおいて、私たちの採用支援システムはIndeed 対応済みとしてリストアップされていません: https://jp.indeed.com/%E6%B1%82%E4%BA%BA%E5%BA%83%E5%91%8A/ATS%E3%81%A8%E3%81%AE%E4%BD%B5%E7%94%A8 これはIndeed 対応済みの採用支援システムを使うことで他社が享受する大きな利益を、私達が逃しているということです。",
            "適格な候補者をいかに集め獲得するかは、私達にとって最も重要な採用ニーズの一つです。採用支援システムがIndeed に対応することで、Indeed から私達の求人に応募する質の高い求職者の数を、すぐにほぼ倍増させることができます。また追加の費用もかかりません。Indeed の最近のデータによると、Indeed対応済みの採用支援システムを使っている採用企業では、適格な候補者からの応募が88%増加し、応募者一人あたりのコストが67%低下したそうです。",
            "私達の採用支援システムがIndeed に対応できるよう、alliancessupport@indeed.comにメールを送りIndeed アライアンスチームと連絡をとって下さい。",
            "以上、よろしくお願いします。"
        ],
        'nl': [
            "Hierbij willen wij u verzoeken om een aanvraag in te dienen om onze ATS aan te sluiten bij Indeed. Wij zouden onze ATS graag laten opnemen in de lijst ATS onderaan deze pagina: https://be.indeed.com/personeel/ats-integratie?hl=nl. Wanneer wij hierbij zijn aangesloten kunnen wij ook profiteren van de voordelen die anderen op de lijst al genieten.",
            "Een van onze doelen is om gekwalificeerde kandidaten aan te trekken. Door onze ATS bij Indeed aan te sluiten, kunnen wij zonder extra kosten het aantal werkzoekenden die direct op Indeed solliciteren bijna verdubbelen. Volgens recente gegevens van Indeed ontvingen werkgevers met een aangesloten ATS 88% meer gekwalificeerde kandidaten en een besparing in de kosten van 67% per gekwalificeerde kandidaat.",
            "Stuur een e-mail naar het Alliances team van Indeed (alliancessupport@indeed.com) met het verzoek om onze ATS te verbinden.",
            "Met vriendelijke groet, "
        ],
        'pt_BR': [
            "Estou enviando este e-mail para pedir que o nosso sistema de RH seja conectado ao Indeed o mais rápido possível. O nosso sistema de rastreamento de RH (ATS) não aparece na lista de ATS conectados ao Indeed: https://www.indeed.com.br/hire/ats-integration. Isto significa que estamos perdendo os benefícios que outras empresas recebem ao utilizar um sistema de RH concectado ao Indeed.",
            "Uma de nossas necessidades críticas no recrutamento é ter a habilidade de atrair e fornecer candidatos qualificados. Ao conectar o nosso sistema de RH ao Indeed, será possível praticamente dobrar imediatamente o número de candidatos de qualidade que se increvem às nossas vagas pelo Indeed, e sem custo adicional. De acordo com dados recentes do Indeed, empresas que utilizam um sistema de rastreamento de RH (ATS) conectado recebem 88% mais candidatos qualificados e têm uma redução de 67% no custo por candidato qualificado.",
            "Por favor, entre em contato com a Equipe de Parcerias do Indeed para que o nosso sistema de rastreamento (ATS) seja conectado, enviando um e-mail ao alliancessupport@indeed.com.",
            "Sinceramente,	"
        ],
        'pt_PT': [
            "Estou enviando este e-mail para pedir que o nosso sistema de RH seja conectado ao Indeed o mais rápido possível. O nosso sistema de rastreamento de RH (ATS) não aparece na lista de ATS conectados ao Indeed: https://www.indeed.pt/hire/ats-integration. Isto significa que estamos perdendo os benefícios que outras empresas recebem ao utilizar um sistema de RH concectado ao Indeed.",
            "Uma de nossas necessidades críticas no recrutamento é ter a habilidade de atrair e fornecer candidatos qualificados. Ao conectar o nosso sistema de RH ao Indeed, será possível praticamente dobrar imediatamente o número de candidatos de qualidade que se increvem às nossas ofertas pelo Indeed, e sem custo adicional. De acordo com dados recentes do Indeed, empresas que utilizam um sistema de rastreamento de RH (ATS) conectado recebem 88% mais candidatos qualificados e têm uma redução de 67% no custo por candidato qualificado.",
            "Por favor, entre em contacto com a Equipa de Parcerias do Indeed para que o nosso sistema de rastreamento (ATS) seja conectado, enviando um e-mail ao alliancessupport@indeed.com.",
            "Sinceramente, "
        ]
    };

    var titles = {
        'en': 'Request to Connect Our ATS to Indeed',
        'de': 'Anfrage um unser ATS mit Indeed zu verbinden',
        'fr': "Demande d'intégration de votre ATS à Indeed",
        'fr_CA': "Demande d'intégration de votre ATS à Indeed",
        'es': "Petición para conectar nuestro SSC con Indeed",
        'it': "Richiesta per connettere il vostro ATS a Indeed",
        'ja': "Indeed 対応状況に関する要請",
        'nl': "Verzoek om onze ATS te verbinden met Indeed",
        'pt_BR': "Pedido para conectar o nosso sistema de RH (ATS) ao Indeed",
        'pt_PT': "Pedido para conectar o nosso sistema de RH (ATS) ao Indeed"
    };


    var requestInfoBodies = {
        'en': [
            "I'm writing to request information about how my ATS goes about integrating with Indeed, and I would like to connect with someone from the Alliances team about this process.",
            "Thank you for attention to this request."
        ]
    };

    var requestInfoTitles = {
        'en': "ATS seeking guidance on integrating with Indeed"
    };

    if($ats_select === undefined){
        bodies = requestInfoBodies;
        titles = requestInfoTitles;
    }

    var locale = [];
    var email_title = '';
    var email_body = '';

    var classes = $('.ats-partner').attr('class').split(/\s+/);

    $.each(classes, function (index, item) {
        if (item.match(/[a-z]{2}_[A-Z]{2}/)) {
            locale = item.split('_');
        }
    });

    if (!locale) {
        locale = ['en'];
    }

    if (Object.keys(bodies).indexOf(locale.join('_')) > -1) {
        email_body = bodies[locale.join('_')].join('\n');
    } else {
        if (Object.keys(bodies).indexOf(locale[0]) > -1) {
            email_body = bodies[locale[0]].join('\n');
        } else {
            email_body = bodies['en'].join('\n');
        }
    }

    if (Object.keys(titles).indexOf(locale.join('_')) > -1) {
        email_title = titles[locale.join('_')];
    } else {
        if (Object.keys(titles).indexOf(locale[0]) > -1) {
            email_title = titles[locale[0]];
        } else {
            email_title = titles['en'];
        }
    }

    if($ats_select === undefined){
        window.location = "mailto:" + "alliancessupport@indeed.com?subject=" + encodedText(email_title) + "&body=" + encodedText(email_body);
    }
    else {
        window.location = "mailto:" + $ats_select.val() + "?cc=alliancessupport@indeed.com&subject=" + encodedText(email_title) + "&body=" + encodedText(email_body);
    }
}

function formatContact(addr) {
    var tmpAddr = addr.split('^^^');
    return tmpAddr[0] + '@' + tmpAddr[1];
}

function addOption(e,optionValue, optionInnerHTML) {
    var optionNode = document.createElement('option');
    optionNode.value = optionValue;
    optionNode.innerHTML = optionInnerHTML;
    for(var idx=0; idx<e.length; idx++){
        e[idx].appendChild(optionNode);
    }
}

function encodedText(str) {
    var encodedStr = encodeURIComponent(str);
    // ensure line breaks and %20 for spaces
    encodedStr = encodedStr.replace(new RegExp("%0A", "g"), "%0A%0A");
    return encodedStr;
}
window.onload = function () {
    populateEmail();
};

function populateEmail() {
    // the first element of each subarray is the ATS name, and the rest are the contact email addresses.
    var atsNamesAndEmails = [
        ["Abso","ClientServices^^^abso.com"],
        ["Advorto","david.pryce^^^advorto.com"],
        ["Apoint+","andy.pierson^^^networxrecruitment.net"],
        ["Applitrack","abe^^^aspexsolutions.com","support^^^aspexsolutions.com"],
        ["bfound.net","gayleen^^^findly.com","caro^^^findly.com"],
        ["Big Red Sky","chris.savage^^^thomsonreuters.com","sales^^^bigredsky.com"],
        ["Brassring","ggopal^^^us.ibm.com"],
        ["Changeworknow","Lisa.Proctor^^^changeworknow.co.uk","Sharon.Wilson^^^changeworknow.co.uk"],
        ["Connexys","meijer^^^connexys.com","bentvelzen^^^connexys.com"],
        ["CV Tools","jorgeoriol^^^cvtools.com","ferran^^^cvtools.com","cvtools^^^cvtools.es"],
        ["CVmail","chris.savage^^^thomsonreuters.com","firmsupport^^^cvmail.net"],
        ["CVweb","s.zagaria^^^cesop.it"],
        ["Cyber Recruiter","cpomeroy^^^visibilitysoftware.com","Sales^^^VisibilitySoftware.com"],
        ["eArcu","andy.randall^^^earcu.com"],
        ["Elancers","anunes^^^elancers.net","fabio^^^elancers.net"],
        ["Emply","ga^^^emply.dk","ma^^^emply.net"],
        ["Eploy","chris.bogh^^^eploy.co.uk"],
        ["ERC Dataplus"],
        ["Ezijob/LHR","holt^^^lhr.com.au"],
        ["FastTrack","jquirk^^^fasttrack.com.au","namisano^^^fasttrack.com.au","support^^^fasttrack.com.au"],
        ["Galileo","info^^^galileo-ats.com"],
        ["Halogen Software","beyre^^^halogensoftware.com","mgaines^^^halogensoftware.com","support^^^halogensoftware.co.uk"],
        ["Hirefuel","emary.vasquez^^^employmentguide.com","support^^^hirefuel.zendesk.com"],
        ["HR4YOU","axel.rekemeyer^^^hr4you.de","d.meyer^^^hr4you.de"],
        ["HRLogix","mike.hargrove^^^findly.com","mike^^^findly.com"],
        ["HROffice","hans^^^adver.nl","marjign^^^hroffice.com"],
        ["HRsmart","clientrelations^^^hrsmart.com"],
        ["Humanic","jspirig^^^humanic.com","tmoberg^^^humanic.com"],
        ["HumanSourcing","mc^^^humansourcing.com","e.royer^^^humansourcing.com","info^^^humansourcing.com"],
        ["Humanway"],
        ["I-Recruit","bkelly^^^cmshris.com","dedgecomb^^^cmshris.com"],
        ["iCIMS","iCIMSProdMgrs^^^icims.com"],
        ["Identified(Facebook App)","erik^^^identified.com"],
        ["iGreentree","Support^^^GreentreeSystems.com"],
        ["iKrut"],
        ["Infoniqa","Eugen.Kimmerstorfer^^^infoniqa.com"],
        ["Jobaline","miki^^^jobaline.com"],
        ["JobApp Plus","jdipaulo^^^jobappplus.com","Info^^^JobAppPlus.com"],
        ["Jobtrain"],
        ["Jobtrain","charles.england^^^jobtrain.co.uk"],
        ["Jobvite","skip^^^jobvite.com"],
        ["Kombo","alessandro^^^kombo.com.br","contato^^^kombo.com.br"],
        ["Kronos","lynne.levy^^^kronos.com","customerupdates^^^kronos.com"],
        ["Leme Consultoria","elsimar^^^lemeconsultoria.com.br","contato^^^lemeconsultoria.com.br"],
        ["Lever","amy^^^lever.co","kelsey^^^lever.co","support^^^lever.co"],
        ["LG Systemas","mporto^^^lg.com.br"],
        ["Luceo","Molly.Ronovsky^^^luceous.com"],
        ["Lumesse EasyCruit","matthijs.vanetten^^^lumesse.com","shelley.ingram^^^lumesse.com"],
        ["Lumesse I-GRasp","matthijs.vanetten^^^lumesse.com","shelley.ingram^^^lumesse.com"],
        ["Lumesse TalentLink","matthijs.vanetten^^^lumesse.com","shelley.ingram^^^lumesse.com"],
        ["Navicus","jherron^^^navicus.com"],
        ["NewHire","csmith^^^new-hire.com"],
        ["Njoyn","info.sales^^^njoyn.com"],
        ["NowHire","SalesSupport^^^nowhire.com"],
        ["PageUp People","simonc^^^pageuppeople.com","peterd^^^pageuppeople.com"],
        ["Parrell Partners","ferdi^^^parallel.co.za","martin^^^parallel.co.za"],
        ["PeopleAnswers","Larry.Chandler^^^infor.com","info^^^peopleanswers.com"],
        ["peoplebank","siobhain.murdoch^^^peoplebank.com"],
        ["Peoplefluent","didier.guzman^^^peoplefluent.com"],
        ["Phoenix ATS","mel^^^phoenixats.com","support^^^PhoenixATS.com"],
        ["Profilsoft"],
        ["Recutsosimple","sales^^^recruitsosimple.co.uk"],
        ["Resfly","tony^^^catsone.com"],
        ["ResumeWare","kirk.boecker^^^resumeware.com","support^^^resumeware.com"],
        ["ResuWe","jeff^^^resuwe.com","questions^^^resuwe.com"],
        ["Rexx systems","arne.nissen^^^rexx-systems.com"],
        ["Scout E-Recruitment","andrea.tjoeng^^^employmentoffice.com.au","will.smith^^^scouterecruit.com"],
        ["Snaphire","mgilmore^^^snaphire.com","hankins^^^snaphire.com","support^^^snaphire.com"],
        ["SortIQ"],["SuccessFactors"],
        ["Talentsoft","contact^^^talentsoft.com"],
        ["Ultimate Software","jennifer_brafman^^^ultimatesoftware.com","ultiproinfo^^^ultimatesoftware.com"],
        ["Unrabble","support^^^unrabble.com"],
        ["Vacancy filler","Fola.Adeniji^^^vacancyfiller.co.uk","Tony.Brookes^^^vacancyfiller.co.uk"],
        ["VirtualEdge","Nathan.Acker^^^adp.com"],
        ["VONQ","wouter^^^vonq.nl"],
        ["WCN","david.moore^^^wcn.co.uk"],
        ["Webcruit"],
        ["willbehired","CCD^^^trinet.com"],
        ["Workbuster"],
        ["Workstream","Liz.Wamsteeker^^^hrsoft.com","info^^^workstreaminc.com"],
        ["World Manager","wendyd^^^worldmanager.com","MarleyV^^^worldmanager.com","ausinfo^^^worldmanager.com"],
        ["Youcruit","mats.holmback^^^youcruit.com"]];

    var emailArray = new Array(); // mailto
    var tempEmail = '';


    // create select box
    var elems = document.getElementsByClassName('ats-form__select');

    var selectAnAts = $('.ats-form__label').text();
    if(selectAnAts === undefined){
        selectAnAts = "Select an ATS";
    }
    addOption(elems, '', selectAnAts);

    // populate options
    for (var i=0; i<atsNamesAndEmails.length; i++) {
        emailArray[i] = '';

        for (var j=1; j<atsNamesAndEmails[i].length; j++) {
            emailArray[i] = emailArray[i] + formatContact(atsNamesAndEmails[i][j]) + ',';
        }
        if (emailArray[i].length) {
            addOption(elems, emailArray[i].slice(0,-1), atsNamesAndEmails[i][0]);
        }
    }

    var other = $('#selectOther').html();
    if(other === undefined){
        other = "Other";
    }

    addOption(elems, '', other);

    //reset select2
    $('.select2').remove();
    var $ats_select = $('select').select2({
        minimumResultsForSearch: Infinity
    });

    $('.ats-form').submit(function(e){
        e.preventDefault();
        sendEmail($ats_select);
    });

}

function sendEmail($ats_select) {

    var bodies = {
        'en': [
            "I'm sending this email to request that you connect our ATS to Indeed as soon as possible. Our ATS is not listed as a connected ATS here: https://www.indeed.com/hire/ats-integration. This means we are missing out on significant benefits other companies have by using an ATS that's connected to Indeed.",
            "One of our most critical recruitment needs is having the ability to attract and source qualified applicants. By connecting our ATS with Indeed, we can nearly double the number of high-quality job seekers that apply to our jobs from Indeed immediately, and at no additional cost. According to recent data from Indeed, employers using a connected ATS received 88% more qualified applicants and experienced a 67% decrease in cost per qualified applicant.",
            "Please contact Indeed's Alliances team to connect our ATS by sending an email to alliancessupport@indeed.com.",
            "Best,"
        ],
        'de': [
            "Mit dieser E-Mail bitten wir Sie, unser ATS so schnell wie möglich mit Indeed zu verbinden. Unser ATS wird nicht als ein mit Indeed integrierbares ATS gelistet: https://de.indeed.com/recruiting/bewerbermanagementsysteme. Dies bedeutet, dass wir die Vorteile, die andere, bereits mit Indeed integrierte Unternehmen genießen, nicht nutzen können.",
            "Zu unseren wichtigsten Recruitment-Bedürfnissen gehört es, geeignete Kandidaten zu gewinnen. Durch die Integration unseres ATS mit Indeed können wir die Anzahl geeigneter Bewerber ohne zusätzliche Kosten sofort deutlich erhöhen.",
            "Bitte kontaktieren Sie das Indeed Alliances Team unter alliancessupport@indeed.com, um unser ATS zu integrieren.",
            "Mit freundlichen Grüßen"
        ],
        'fr': [
            "Je me permets de vous écrire cet email afin de vous encourager à connecter votre ATS à Indeed le plus vite possible. En effet, votre ATS n'est pas listé sur cette page : https://www.indeed.fr/recrutement/integration-ats. Ce qui signifie que vous ne bénéficiez pas d'avantages auxquels d'autres entreprises ont accès en utilisant un ATS qui est connecté à Indeed.",
            "L'un des besoins essentiels lorsque que l'on recrute est la capacité à trouver et attirer des candidats qualifiés. En connectant votre ATS à Indeed, vous pouvez presque doubler instantanément et sans frais supplémentaires le nombre de chercheurs d'emploi de qualité qui postulent à vos offres depuis Indeed.\nD'après les données récentes d'Indeed, les employeurs utilisant un ATS connecté reçoivent 88 % de candidats qualifiés en plus et voient leur coût par candidats qualifiés baisser de 67 %.",
            "Veuillez contacter l'équipe Alliances afin de connecter votre ATS à Indeed en envoyant un email à l'adresse alliancessupport@indeed.com.",
            "Cordialement"
        ],
        'fr_CA': [
            "Je me permets de vous écrire ce courriel afin de vous encourager à connecter votre ATS à Indeed le plus vite possible. En effet, votre ATS n'est pas listé sur cette page : https://emplois.ca.indeed.com/recrutement/integration-ats. Ce qui signifie que vous ne bénéficiez pas de certains des avantages auxquels d'autres entreprises ont accès en utilisant un ATS connecté à Indeed.",
            "L'un des besoins essentiels lorsque que l'on recrute est la capacité à trouver et attirer des candidats qualifiés. En connectant votre ATS à Indeed, vous pouvez presque doubler instantanément et sans frais supplémentaires le nombre de chercheurs d'emploi de qualité qui postulent à vos offres depuis Indeed.\{lbn}D'après les données récentes d'Indeed, les employeurs utilisant un ATS connecté reçoivent 88 % de candidats qualifiés en plus et voient leur coût par candidats qualifiés baisser de 67 %.",
            "Pour connecter votre ATS à Indeed, contactez l'equipe Alliances en envoyant un courriel à alliancessupport@indeed.com.",
            "Cordialement"
        ],
        'es': [
            "Envío este email para solicitar conectar nuestro SSC con Indeed lo antes posible. Nuestro SSC no está incluida aquí: https://www.indeed.com/hire/ats-integration. Esto supone que estamos perdiendo los beneficios que otras empresas obtienen usando un SSC conectado con Indeed.",
            "Una de nuestras necesidades críticas de reclutamiento es atraer y manejar candidatos cualificados. Al conectar nuestro SSC con Indeed, podemos casi duplicar el número de candidatos de alta calidad que postulan a nuestros empleos desde Indeed de forma inmediata y sin coste adicional. Según datos recientes de Indeed, la empresas que usan un SSC conectado reciben un 88% más de candidatos cualificados y disfrutan un descenso del 67% en el coste por candidato cualificado.",
            "Por favor contacte con el equipo de alianzas de Indeed para conectar nuestro SSC enviando un email a alliancessupport@indeed.com.",
            "Un saludo,"
        ],
        'it': [
            "Vi scrivo per richiedere la connessione del vostro ATS con Indeed, il prima possibile. Il vostro ATS non è compreso nella lista degli ATS connessi a Indeed: https://it.indeed.com/recruiting/integrazione-ats. Di conseguenza non stiamo beneficiando dei vantaggi che altre aziende hanno ricevuto con un ATS connesso a Indeed.",
            "Uno dei problemi più importanti nel campo delle risorse umane è quello di attrarre e assumere candidati qualificati. Connettendo il vostro ATS con Indeed, potremmo raddoppiare il numero di candidati qualificati che possono candidarsi alle nostre offerte di lavoro. Sulla base di dati recenti pubblicati da Indeed, le aziende che usano un ATS connesso ricevono l'88% in più di candidati qualificati con un risparmio del 67% per candidato.",
            "Per connettere il vostro ATS, potete contattare l'Alliance Team di Indeed a: alliancessupport@indeed.com.",
            "Cordiali saluti,"
        ],
        'ja': [
            "私達の採用支援システムがIndeed になるべく早期に対応できるよう、メールにて要請します。 以下のページにおいて、私たちの採用支援システムはIndeed 対応済みとしてリストアップされていません: https://jp.indeed.com/%E6%B1%82%E4%BA%BA%E5%BA%83%E5%91%8A/ATS%E3%81%A8%E3%81%AE%E4%BD%B5%E7%94%A8 これはIndeed 対応済みの採用支援システムを使うことで他社が享受する大きな利益を、私達が逃しているということです。",
            "適格な候補者をいかに集め獲得するかは、私達にとって最も重要な採用ニーズの一つです。採用支援システムがIndeed に対応することで、Indeed から私達の求人に応募する質の高い求職者の数を、すぐにほぼ倍増させることができます。また追加の費用もかかりません。Indeed の最近のデータによると、Indeed対応済みの採用支援システムを使っている採用企業では、適格な候補者からの応募が88%増加し、応募者一人あたりのコストが67%低下したそうです。",
            "私達の採用支援システムがIndeed に対応できるよう、alliancessupport@indeed.comにメールを送りIndeed アライアンスチームと連絡をとって下さい。",
            "以上、よろしくお願いします。"
        ],
        'nl': [
            "Hierbij willen wij u verzoeken om een aanvraag in te dienen om onze ATS aan te sluiten bij Indeed. Wij zouden onze ATS graag laten opnemen in de lijst ATS onderaan deze pagina: https://be.indeed.com/personeel/ats-integratie?hl=nl. Wanneer wij hierbij zijn aangesloten kunnen wij ook profiteren van de voordelen die anderen op de lijst al genieten.",
            "Een van onze doelen is om gekwalificeerde kandidaten aan te trekken. Door onze ATS bij Indeed aan te sluiten, kunnen wij zonder extra kosten het aantal werkzoekenden die direct op Indeed solliciteren bijna verdubbelen. Volgens recente gegevens van Indeed ontvingen werkgevers met een aangesloten ATS 88% meer gekwalificeerde kandidaten en een besparing in de kosten van 67% per gekwalificeerde kandidaat.",
            "Stuur een e-mail naar het Alliances team van Indeed (alliancessupport@indeed.com) met het verzoek om onze ATS te verbinden.",
            "Met vriendelijke groet, "
        ],
        'pt_BR': [
            "Estou enviando este e-mail para pedir que o nosso sistema de RH seja conectado ao Indeed o mais rápido possível. O nosso sistema de rastreamento de RH (ATS) não aparece na lista de ATS conectados ao Indeed: https://www.indeed.com.br/hire/ats-integration. Isto significa que estamos perdendo os benefícios que outras empresas recebem ao utilizar um sistema de RH concectado ao Indeed.",
            "Uma de nossas necessidades críticas no recrutamento é ter a habilidade de atrair e fornecer candidatos qualificados. Ao conectar o nosso sistema de RH ao Indeed, será possível praticamente dobrar imediatamente o número de candidatos de qualidade que se increvem às nossas vagas pelo Indeed, e sem custo adicional. De acordo com dados recentes do Indeed, empresas que utilizam um sistema de rastreamento de RH (ATS) conectado recebem 88% mais candidatos qualificados e têm uma redução de 67% no custo por candidato qualificado.",
            "Por favor, entre em contato com a Equipe de Parcerias do Indeed para que o nosso sistema de rastreamento (ATS) seja conectado, enviando um e-mail ao alliancessupport@indeed.com.",
            "Sinceramente,	"
        ],
        'pt_PT': [
            "Estou enviando este e-mail para pedir que o nosso sistema de RH seja conectado ao Indeed o mais rápido possível. O nosso sistema de rastreamento de RH (ATS) não aparece na lista de ATS conectados ao Indeed: https://www.indeed.pt/hire/ats-integration. Isto significa que estamos perdendo os benefícios que outras empresas recebem ao utilizar um sistema de RH concectado ao Indeed.",
            "Uma de nossas necessidades críticas no recrutamento é ter a habilidade de atrair e fornecer candidatos qualificados. Ao conectar o nosso sistema de RH ao Indeed, será possível praticamente dobrar imediatamente o número de candidatos de qualidade que se increvem às nossas ofertas pelo Indeed, e sem custo adicional. De acordo com dados recentes do Indeed, empresas que utilizam um sistema de rastreamento de RH (ATS) conectado recebem 88% mais candidatos qualificados e têm uma redução de 67% no custo por candidato qualificado.",
            "Por favor, entre em contacto com a Equipa de Parcerias do Indeed para que o nosso sistema de rastreamento (ATS) seja conectado, enviando um e-mail ao alliancessupport@indeed.com.",
            "Sinceramente, "
        ]
    };

    var titles = {
        'en': 'Request to Connect Our ATS to Indeed',
        'de': 'Anfrage um unser ATS mit Indeed zu verbinden',
        'fr': "Demande d'intégration de votre ATS à Indeed",
        'fr_CA': "Demande d'intégration de votre ATS à Indeed",
        'es': "Petición para conectar nuestro SSC con Indeed",
        'it': "Richiesta per connettere il vostro ATS a Indeed",
        'ja': "Indeed 対応状況に関する要請",
        'nl': "Verzoek om onze ATS te verbinden met Indeed",
        'pt_BR': "Pedido para conectar o nosso sistema de RH (ATS) ao Indeed",
        'pt_PT': "Pedido para conectar o nosso sistema de RH (ATS) ao Indeed"
    };


    var requestInfoBodies = {
        'en': [
            "I'm writing to request information about how my ATS goes about integrating with Indeed, and I would like to connect with someone from the Alliances team about this process.",
            "Thank you for attention to this request."
        ]
    };

    var requestInfoTitles = {
        'en': "ATS seeking guidance on integrating with Indeed"
    };

    if($ats_select === undefined){
        bodies = requestInfoBodies;
        titles = requestInfoTitles;
    }

    var locale = [];
    var email_title = '';
    var email_body = '';

    var classes = $('.ats-partner').attr('class').split(/\s+/);

    $.each(classes, function (index, item) {
        if (item.match(/[a-z]{2}_[A-Z]{2}/)) {
            locale = item.split('_');
        }
    });

    if (!locale) {
        locale = ['en'];
    }

    if (Object.keys(bodies).indexOf(locale.join('_')) > -1) {
        email_body = bodies[locale.join('_')].join('\n');
    } else {
        if (Object.keys(bodies).indexOf(locale[0]) > -1) {
            email_body = bodies[locale[0]].join('\n');
        } else {
            email_body = bodies['en'].join('\n');
        }
    }

    if (Object.keys(titles).indexOf(locale.join('_')) > -1) {
        email_title = titles[locale.join('_')];
    } else {
        if (Object.keys(titles).indexOf(locale[0]) > -1) {
            email_title = titles[locale[0]];
        } else {
            email_title = titles['en'];
        }
    }

    if($ats_select === undefined){
        window.location = "mailto:" + "alliancessupport@indeed.com?subject=" + encodedText(email_title) + "&body=" + encodedText(email_body);
    }
    else {
        window.location = "mailto:" + $ats_select.val() + "?cc=alliancessupport@indeed.com&subject=" + encodedText(email_title) + "&body=" + encodedText(email_body);
    }
}

function formatContact(addr) {
    var tmpAddr = addr.split('^^^');
    return tmpAddr[0] + '@' + tmpAddr[1];
}

function addOption(e,optionValue, optionInnerHTML) {
    var optionNode = document.createElement('option');
    optionNode.value = optionValue;
    optionNode.innerHTML = optionInnerHTML;
    for(var idx=0; idx<e.length; idx++){
        e[idx].appendChild(optionNode);
    }
}

function encodedText(str) {
    var encodedStr = encodeURIComponent(str);
    // ensure line breaks and %20 for spaces
    encodedStr = encodedStr.replace(new RegExp("%0A", "g"), "%0A%0A");
    return encodedStr;
}
window.onload = function () {
    populateEmail();
};

function populateEmail() {
    // the first element of each subarray is the ATS name, and the rest are the contact email addresses.
    var atsNamesAndEmails = [
        ["Abso","ClientServices^^^abso.com"],
        ["Advorto","david.pryce^^^advorto.com"],
        ["Apoint+","andy.pierson^^^networxrecruitment.net"],
        ["Applitrack","abe^^^aspexsolutions.com","support^^^aspexsolutions.com"],
        ["bfound.net","gayleen^^^findly.com","caro^^^findly.com"],
        ["Big Red Sky","chris.savage^^^thomsonreuters.com","sales^^^bigredsky.com"],
        ["Brassring","ggopal^^^us.ibm.com"],
        ["Changeworknow","Lisa.Proctor^^^changeworknow.co.uk","Sharon.Wilson^^^changeworknow.co.uk"],
        ["Connexys","meijer^^^connexys.com","bentvelzen^^^connexys.com"],
        ["CV Tools","jorgeoriol^^^cvtools.com","ferran^^^cvtools.com","cvtools^^^cvtools.es"],
        ["CVmail","chris.savage^^^thomsonreuters.com","firmsupport^^^cvmail.net"],
        ["CVweb","s.zagaria^^^cesop.it"],
        ["Cyber Recruiter","cpomeroy^^^visibilitysoftware.com","Sales^^^VisibilitySoftware.com"],
        ["eArcu","andy.randall^^^earcu.com"],
        ["Elancers","anunes^^^elancers.net","fabio^^^elancers.net"],
        ["Emply","ga^^^emply.dk","ma^^^emply.net"],
        ["Eploy","chris.bogh^^^eploy.co.uk"],
        ["ERC Dataplus"],
        ["Ezijob/LHR","holt^^^lhr.com.au"],
        ["FastTrack","jquirk^^^fasttrack.com.au","namisano^^^fasttrack.com.au","support^^^fasttrack.com.au"],
        ["Galileo","info^^^galileo-ats.com"],
        ["Halogen Software","beyre^^^halogensoftware.com","mgaines^^^halogensoftware.com","support^^^halogensoftware.co.uk"],
        ["Hirefuel","emary.vasquez^^^employmentguide.com","support^^^hirefuel.zendesk.com"],
        ["HR4YOU","axel.rekemeyer^^^hr4you.de","d.meyer^^^hr4you.de"],
        ["HRLogix","mike.hargrove^^^findly.com","mike^^^findly.com"],
        ["HROffice","hans^^^adver.nl","marjign^^^hroffice.com"],
        ["HRsmart","clientrelations^^^hrsmart.com"],
        ["Humanic","jspirig^^^humanic.com","tmoberg^^^humanic.com"],
        ["HumanSourcing","mc^^^humansourcing.com","e.royer^^^humansourcing.com","info^^^humansourcing.com"],
        ["Humanway"],
        ["I-Recruit","bkelly^^^cmshris.com","dedgecomb^^^cmshris.com"],
        ["iCIMS","iCIMSProdMgrs^^^icims.com"],
        ["Identified(Facebook App)","erik^^^identified.com"],
        ["iGreentree","Support^^^GreentreeSystems.com"],
        ["iKrut"],
        ["Infoniqa","Eugen.Kimmerstorfer^^^infoniqa.com"],
        ["Jobaline","miki^^^jobaline.com"],
        ["JobApp Plus","jdipaulo^^^jobappplus.com","Info^^^JobAppPlus.com"],
        ["Jobtrain"],
        ["Jobtrain","charles.england^^^jobtrain.co.uk"],
        ["Jobvite","skip^^^jobvite.com"],
        ["Kombo","alessandro^^^kombo.com.br","contato^^^kombo.com.br"],
        ["Kronos","lynne.levy^^^kronos.com","customerupdates^^^kronos.com"],
        ["Leme Consultoria","elsimar^^^lemeconsultoria.com.br","contato^^^lemeconsultoria.com.br"],
        ["Lever","amy^^^lever.co","kelsey^^^lever.co","support^^^lever.co"],
        ["LG Systemas","mporto^^^lg.com.br"],
        ["Luceo","Molly.Ronovsky^^^luceous.com"],
        ["Lumesse EasyCruit","matthijs.vanetten^^^lumesse.com","shelley.ingram^^^lumesse.com"],
        ["Lumesse I-GRasp","matthijs.vanetten^^^lumesse.com","shelley.ingram^^^lumesse.com"],
        ["Lumesse TalentLink","matthijs.vanetten^^^lumesse.com","shelley.ingram^^^lumesse.com"],
        ["Navicus","jherron^^^navicus.com"],
        ["NewHire","csmith^^^new-hire.com"],
        ["Njoyn","info.sales^^^njoyn.com"],
        ["NowHire","SalesSupport^^^nowhire.com"],
        ["PageUp People","simonc^^^pageuppeople.com","peterd^^^pageuppeople.com"],
        ["Parrell Partners","ferdi^^^parallel.co.za","martin^^^parallel.co.za"],
        ["PeopleAnswers","Larry.Chandler^^^infor.com","info^^^peopleanswers.com"],
        ["peoplebank","siobhain.murdoch^^^peoplebank.com"],
        ["Peoplefluent","didier.guzman^^^peoplefluent.com"],
        ["Phoenix ATS","mel^^^phoenixats.com","support^^^PhoenixATS.com"],
        ["Profilsoft"],
        ["Recutsosimple","sales^^^recruitsosimple.co.uk"],
        ["Resfly","tony^^^catsone.com"],
        ["ResumeWare","kirk.boecker^^^resumeware.com","support^^^resumeware.com"],
        ["ResuWe","jeff^^^resuwe.com","questions^^^resuwe.com"],
        ["Rexx systems","arne.nissen^^^rexx-systems.com"],
        ["Scout E-Recruitment","andrea.tjoeng^^^employmentoffice.com.au","will.smith^^^scouterecruit.com"],
        ["Snaphire","mgilmore^^^snaphire.com","hankins^^^snaphire.com","support^^^snaphire.com"],
        ["SortIQ"],["SuccessFactors"],
        ["Talentsoft","contact^^^talentsoft.com"],
        ["Ultimate Software","jennifer_brafman^^^ultimatesoftware.com","ultiproinfo^^^ultimatesoftware.com"],
        ["Unrabble","support^^^unrabble.com"],
        ["Vacancy filler","Fola.Adeniji^^^vacancyfiller.co.uk","Tony.Brookes^^^vacancyfiller.co.uk"],
        ["VirtualEdge","Nathan.Acker^^^adp.com"],
        ["VONQ","wouter^^^vonq.nl"],
        ["WCN","david.moore^^^wcn.co.uk"],
        ["Webcruit"],
        ["willbehired","CCD^^^trinet.com"],
        ["Workbuster"],
        ["Workstream","Liz.Wamsteeker^^^hrsoft.com","info^^^workstreaminc.com"],
        ["World Manager","wendyd^^^worldmanager.com","MarleyV^^^worldmanager.com","ausinfo^^^worldmanager.com"],
        ["Youcruit","mats.holmback^^^youcruit.com"]];

    var emailArray = new Array(); // mailto
    var tempEmail = '';


    // create select box
    var elems = document.getElementsByClassName('ats-form__select');

    var selectAnAts = $('.ats-form__label').text();
    if(selectAnAts === undefined){
        selectAnAts = "Select an ATS";
    }
    addOption(elems, '', selectAnAts);

    // populate options
    for (var i=0; i<atsNamesAndEmails.length; i++) {
        emailArray[i] = '';

        for (var j=1; j<atsNamesAndEmails[i].length; j++) {
            emailArray[i] = emailArray[i] + formatContact(atsNamesAndEmails[i][j]) + ',';
        }
        if (emailArray[i].length) {
            addOption(elems, emailArray[i].slice(0,-1), atsNamesAndEmails[i][0]);
        }
    }

    var other = $('#selectOther').html();
    if(other === undefined){
        other = "Other";
    }

    addOption(elems, '', other);

    //reset select2
    $('.select2').remove();
    var $ats_select = $('select').select2({
        minimumResultsForSearch: Infinity
    });

    $('.ats-form').submit(function(e){
        e.preventDefault();
        sendEmail($ats_select);
    });

}

function sendEmail($ats_select) {

    var bodies = {
        'en': [
            "I'm sending this email to request that you connect our ATS to Indeed as soon as possible. Our ATS is not listed as a connected ATS here: https://www.indeed.com/hire/ats-integration. This means we are missing out on significant benefits other companies have by using an ATS that's connected to Indeed.",
            "One of our most critical recruitment needs is having the ability to attract and source qualified applicants. By connecting our ATS with Indeed, we can nearly double the number of high-quality job seekers that apply to our jobs from Indeed immediately, and at no additional cost. According to recent data from Indeed, employers using a connected ATS received 88% more qualified applicants and experienced a 67% decrease in cost per qualified applicant.",
            "Please contact Indeed's Alliances team to connect our ATS by sending an email to alliancessupport@indeed.com.",
            "Best,"
        ],
        'de': [
            "Mit dieser E-Mail bitten wir Sie, unser ATS so schnell wie möglich mit Indeed zu verbinden. Unser ATS wird nicht als ein mit Indeed integrierbares ATS gelistet: https://de.indeed.com/recruiting/bewerbermanagementsysteme. Dies bedeutet, dass wir die Vorteile, die andere, bereits mit Indeed integrierte Unternehmen genießen, nicht nutzen können.",
            "Zu unseren wichtigsten Recruitment-Bedürfnissen gehört es, geeignete Kandidaten zu gewinnen. Durch die Integration unseres ATS mit Indeed können wir die Anzahl geeigneter Bewerber ohne zusätzliche Kosten sofort deutlich erhöhen.",
            "Bitte kontaktieren Sie das Indeed Alliances Team unter alliancessupport@indeed.com, um unser ATS zu integrieren.",
            "Mit freundlichen Grüßen"
        ],
        'fr': [
            "Je me permets de vous écrire cet email afin de vous encourager à connecter votre ATS à Indeed le plus vite possible. En effet, votre ATS n'est pas listé sur cette page : https://www.indeed.fr/recrutement/integration-ats. Ce qui signifie que vous ne bénéficiez pas d'avantages auxquels d'autres entreprises ont accès en utilisant un ATS qui est connecté à Indeed.",
            "L'un des besoins essentiels lorsque que l'on recrute est la capacité à trouver et attirer des candidats qualifiés. En connectant votre ATS à Indeed, vous pouvez presque doubler instantanément et sans frais supplémentaires le nombre de chercheurs d'emploi de qualité qui postulent à vos offres depuis Indeed.\nD'après les données récentes d'Indeed, les employeurs utilisant un ATS connecté reçoivent 88 % de candidats qualifiés en plus et voient leur coût par candidats qualifiés baisser de 67 %.",
            "Veuillez contacter l'équipe Alliances afin de connecter votre ATS à Indeed en envoyant un email à l'adresse alliancessupport@indeed.com.",
            "Cordialement"
        ],
        'fr_CA': [
            "Je me permets de vous écrire ce courriel afin de vous encourager à connecter votre ATS à Indeed le plus vite possible. En effet, votre ATS n'est pas listé sur cette page : https://emplois.ca.indeed.com/recrutement/integration-ats. Ce qui signifie que vous ne bénéficiez pas de certains des avantages auxquels d'autres entreprises ont accès en utilisant un ATS connecté à Indeed.",
            "L'un des besoins essentiels lorsque que l'on recrute est la capacité à trouver et attirer des candidats qualifiés. En connectant votre ATS à Indeed, vous pouvez presque doubler instantanément et sans frais supplémentaires le nombre de chercheurs d'emploi de qualité qui postulent à vos offres depuis Indeed.\{lbn}D'après les données récentes d'Indeed, les employeurs utilisant un ATS connecté reçoivent 88 % de candidats qualifiés en plus et voient leur coût par candidats qualifiés baisser de 67 %.",
            "Pour connecter votre ATS à Indeed, contactez l'equipe Alliances en envoyant un courriel à alliancessupport@indeed.com.",
            "Cordialement"
        ],
        'es': [
            "Envío este email para solicitar conectar nuestro SSC con Indeed lo antes posible. Nuestro SSC no está incluida aquí: https://www.indeed.com/hire/ats-integration. Esto supone que estamos perdiendo los beneficios que otras empresas obtienen usando un SSC conectado con Indeed.",
            "Una de nuestras necesidades críticas de reclutamiento es atraer y manejar candidatos cualificados. Al conectar nuestro SSC con Indeed, podemos casi duplicar el número de candidatos de alta calidad que postulan a nuestros empleos desde Indeed de forma inmediata y sin coste adicional. Según datos recientes de Indeed, la empresas que usan un SSC conectado reciben un 88% más de candidatos cualificados y disfrutan un descenso del 67% en el coste por candidato cualificado.",
            "Por favor contacte con el equipo de alianzas de Indeed para conectar nuestro SSC enviando un email a alliancessupport@indeed.com.",
            "Un saludo,"
        ],
        'it': [
            "Vi scrivo per richiedere la connessione del vostro ATS con Indeed, il prima possibile. Il vostro ATS non è compreso nella lista degli ATS connessi a Indeed: https://it.indeed.com/recruiting/integrazione-ats. Di conseguenza non stiamo beneficiando dei vantaggi che altre aziende hanno ricevuto con un ATS connesso a Indeed.",
            "Uno dei problemi più importanti nel campo delle risorse umane è quello di attrarre e assumere candidati qualificati. Connettendo il vostro ATS con Indeed, potremmo raddoppiare il numero di candidati qualificati che possono candidarsi alle nostre offerte di lavoro. Sulla base di dati recenti pubblicati da Indeed, le aziende che usano un ATS connesso ricevono l'88% in più di candidati qualificati con un risparmio del 67% per candidato.",
            "Per connettere il vostro ATS, potete contattare l'Alliance Team di Indeed a: alliancessupport@indeed.com.",
            "Cordiali saluti,"
        ],
        'ja': [
            "私達の採用支援システムがIndeed になるべく早期に対応できるよう、メールにて要請します。 以下のページにおいて、私たちの採用支援システムはIndeed 対応済みとしてリストアップされていません: https://jp.indeed.com/%E6%B1%82%E4%BA%BA%E5%BA%83%E5%91%8A/ATS%E3%81%A8%E3%81%AE%E4%BD%B5%E7%94%A8 これはIndeed 対応済みの採用支援システムを使うことで他社が享受する大きな利益を、私達が逃しているということです。",
            "適格な候補者をいかに集め獲得するかは、私達にとって最も重要な採用ニーズの一つです。採用支援システムがIndeed に対応することで、Indeed から私達の求人に応募する質の高い求職者の数を、すぐにほぼ倍増させることができます。また追加の費用もかかりません。Indeed の最近のデータによると、Indeed対応済みの採用支援システムを使っている採用企業では、適格な候補者からの応募が88%増加し、応募者一人あたりのコストが67%低下したそうです。",
            "私達の採用支援システムがIndeed に対応できるよう、alliancessupport@indeed.comにメールを送りIndeed アライアンスチームと連絡をとって下さい。",
            "以上、よろしくお願いします。"
        ],
        'nl': [
            "Hierbij willen wij u verzoeken om een aanvraag in te dienen om onze ATS aan te sluiten bij Indeed. Wij zouden onze ATS graag laten opnemen in de lijst ATS onderaan deze pagina: https://be.indeed.com/personeel/ats-integratie?hl=nl. Wanneer wij hierbij zijn aangesloten kunnen wij ook profiteren van de voordelen die anderen op de lijst al genieten.",
            "Een van onze doelen is om gekwalificeerde kandidaten aan te trekken. Door onze ATS bij Indeed aan te sluiten, kunnen wij zonder extra kosten het aantal werkzoekenden die direct op Indeed solliciteren bijna verdubbelen. Volgens recente gegevens van Indeed ontvingen werkgevers met een aangesloten ATS 88% meer gekwalificeerde kandidaten en een besparing in de kosten van 67% per gekwalificeerde kandidaat.",
            "Stuur een e-mail naar het Alliances team van Indeed (alliancessupport@indeed.com) met het verzoek om onze ATS te verbinden.",
            "Met vriendelijke groet, "
        ],
        'pt_BR': [
            "Estou enviando este e-mail para pedir que o nosso sistema de RH seja conectado ao Indeed o mais rápido possível. O nosso sistema de rastreamento de RH (ATS) não aparece na lista de ATS conectados ao Indeed: https://www.indeed.com.br/hire/ats-integration. Isto significa que estamos perdendo os benefícios que outras empresas recebem ao utilizar um sistema de RH concectado ao Indeed.",
            "Uma de nossas necessidades críticas no recrutamento é ter a habilidade de atrair e fornecer candidatos qualificados. Ao conectar o nosso sistema de RH ao Indeed, será possível praticamente dobrar imediatamente o número de candidatos de qualidade que se increvem às nossas vagas pelo Indeed, e sem custo adicional. De acordo com dados recentes do Indeed, empresas que utilizam um sistema de rastreamento de RH (ATS) conectado recebem 88% mais candidatos qualificados e têm uma redução de 67% no custo por candidato qualificado.",
            "Por favor, entre em contato com a Equipe de Parcerias do Indeed para que o nosso sistema de rastreamento (ATS) seja conectado, enviando um e-mail ao alliancessupport@indeed.com.",
            "Sinceramente,	"
        ],
        'pt_PT': [
            "Estou enviando este e-mail para pedir que o nosso sistema de RH seja conectado ao Indeed o mais rápido possível. O nosso sistema de rastreamento de RH (ATS) não aparece na lista de ATS conectados ao Indeed: https://www.indeed.pt/hire/ats-integration. Isto significa que estamos perdendo os benefícios que outras empresas recebem ao utilizar um sistema de RH concectado ao Indeed.",
            "Uma de nossas necessidades críticas no recrutamento é ter a habilidade de atrair e fornecer candidatos qualificados. Ao conectar o nosso sistema de RH ao Indeed, será possível praticamente dobrar imediatamente o número de candidatos de qualidade que se increvem às nossas ofertas pelo Indeed, e sem custo adicional. De acordo com dados recentes do Indeed, empresas que utilizam um sistema de rastreamento de RH (ATS) conectado recebem 88% mais candidatos qualificados e têm uma redução de 67% no custo por candidato qualificado.",
            "Por favor, entre em contacto com a Equipa de Parcerias do Indeed para que o nosso sistema de rastreamento (ATS) seja conectado, enviando um e-mail ao alliancessupport@indeed.com.",
            "Sinceramente, "
        ]
    };

    var titles = {
        'en': 'Request to Connect Our ATS to Indeed',
        'de': 'Anfrage um unser ATS mit Indeed zu verbinden',
        'fr': "Demande d'intégration de votre ATS à Indeed",
        'fr_CA': "Demande d'intégration de votre ATS à Indeed",
        'es': "Petición para conectar nuestro SSC con Indeed",
        'it': "Richiesta per connettere il vostro ATS a Indeed",
        'ja': "Indeed 対応状況に関する要請",
        'nl': "Verzoek om onze ATS te verbinden met Indeed",
        'pt_BR': "Pedido para conectar o nosso sistema de RH (ATS) ao Indeed",
        'pt_PT': "Pedido para conectar o nosso sistema de RH (ATS) ao Indeed"
    };


    var requestInfoBodies = {
        'en': [
            "I'm writing to request information about how my ATS goes about integrating with Indeed, and I would like to connect with someone from the Alliances team about this process.",
            "Thank you for attention to this request."
        ]
    };

    var requestInfoTitles = {
        'en': "ATS seeking guidance on integrating with Indeed"
    };

    if($ats_select === undefined){
        bodies = requestInfoBodies;
        titles = requestInfoTitles;
    }

    var locale = [];
    var email_title = '';
    var email_body = '';

    var classes = $('.ats-partner').attr('class').split(/\s+/);

    $.each(classes, function (index, item) {
        if (item.match(/[a-z]{2}_[A-Z]{2}/)) {
            locale = item.split('_');
        }
    });

    if (!locale) {
        locale = ['en'];
    }

    if (Object.keys(bodies).indexOf(locale.join('_')) > -1) {
        email_body = bodies[locale.join('_')].join('\n');
    } else {
        if (Object.keys(bodies).indexOf(locale[0]) > -1) {
            email_body = bodies[locale[0]].join('\n');
        } else {
            email_body = bodies['en'].join('\n');
        }
    }

    if (Object.keys(titles).indexOf(locale.join('_')) > -1) {
        email_title = titles[locale.join('_')];
    } else {
        if (Object.keys(titles).indexOf(locale[0]) > -1) {
            email_title = titles[locale[0]];
        } else {
            email_title = titles['en'];
        }
    }

    if($ats_select === undefined){
        window.location = "mailto:" + "alliancessupport@indeed.com?subject=" + encodedText(email_title) + "&body=" + encodedText(email_body);
    }
    else {
        window.location = "mailto:" + $ats_select.val() + "?cc=alliancessupport@indeed.com&subject=" + encodedText(email_title) + "&body=" + encodedText(email_body);
    }
}

function formatContact(addr) {
    var tmpAddr = addr.split('^^^');
    return tmpAddr[0] + '@' + tmpAddr[1];
}

function addOption(e,optionValue, optionInnerHTML) {
    var optionNode = document.createElement('option');
    optionNode.value = optionValue;
    optionNode.innerHTML = optionInnerHTML;
    for(var idx=0; idx<e.length; idx++){
        e[idx].appendChild(optionNode);
    }
}

function encodedText(str) {
    var encodedStr = encodeURIComponent(str);
    // ensure line breaks and %20 for spaces
    encodedStr = encodedStr.replace(new RegExp("%0A", "g"), "%0A%0A");
    return encodedStr;
}

